export const CONTACT_NOTIFICATIONS_REQUEST_PENDING = 'contact_notifications_request_pending';
export const CONTACT_NOTIFICATIONS_RECEIVED = 'contact_notifications_received';
export const CONTACT_NOTIFICATIONS_REQUEST_ERROR = 'contact_notifications_request_error';
export const MARK_STIPULATION_FULFILLED = 'mark_stipulation_fulfilled';
